import './pop-up.jquery.js';

;(function($, window, document, undefined) {
  const pluginName = 'shareBar';

  class ShareBar {
    constructor(element, options) {
      this._name = pluginName;
      this._defaults = $.fn[pluginName].defaults;

      this.element = element;
      this.settings = $.extend(true, this._defaults, options);

      this.init();
    }

    init() {
      this.cacheElements();
      this.bindEvents();

      if (!this.settings.disablePopups) {
        $('.share-bar .share-bar__btn:not(.share-bar__btn--twitter)').popUp();
      }
    }

    cacheElements() {
      this.$element = $(this.element);
      this.$info = this.$element.find('.share-bar__info');
    }

    bindEvents() {
      $(document).on('fbSDK:graph:data:load', this.render.bind(this));
    }

    render(e, data) {
      if (data && data.engagement && data.engagement.share_count > 499) {
        this.$info.html(this.settings.template(data));
        return;
      }

      this.$info.remove();
    }
  }

  $.fn[pluginName] = function (options) {
    return this.each(function() {
      if (!$.data(this, 'plugin_' + pluginName)) {
        $.data(this, 'plugin_' + pluginName, new ShareBar(this, options));
      }
    });
  };

  $.fn[pluginName].defaults = {
    template: require('!handlebars-loader!../../views/desktop/post/share_bar_info_view.html')
  };
})(jQuery, window, document);
